/* eslint-disable no-template-curly-in-string */
import {Provider} from '/src/parents/provider'

class UploadProvider extends Provider {
  multipleUpload(payload) {
    return this.doRequest('POST', `${process.env.VUE_APP_API_URL}/v1/upload/multiple-upload`, payload)
  }
}

export default new UploadProvider()
